import {
  ChevronDownLightIcon,
  ChevronUpLightIcon,
} from '@global-engineering-shared/gweb-global-icons';
import { Box, IconButton } from '@global-engineering-shared/gweb-material-ui';
import React from 'react';

import useStyles from 'components/Table/components/TableItem/components/TableExpandButton/TableExpandButton.styles';

type TableExpandButtonProps = {
  expandOnClick: boolean | undefined;
  isExpanded: boolean;
  setIsExpanded: React.Dispatch<React.SetStateAction<boolean>>;
  hideTitleAccessText: string;
  showTitleAccessText: string;
};

const TableExpandButton = ({
  expandOnClick,
  isExpanded,
  setIsExpanded,
  hideTitleAccessText,
  showTitleAccessText,
}: TableExpandButtonProps) => {
  const classes = useStyles({ isExpanded });

  const handleExpand = () => {
    setIsExpanded((prev) => !prev);
  };

  return (
    <Box className={classes.root}>
      {expandOnClick && (
        <IconButton size="small" onClick={handleExpand} aria-label="Expand button">
          {isExpanded ? (
            <ChevronUpLightIcon fontSize="small" titleAccess={hideTitleAccessText} />
          ) : (
            <ChevronDownLightIcon fontSize="small" titleAccess={showTitleAccessText} />
          )}
        </IconButton>
      )}
    </Box>
  );
};

export default TableExpandButton;
